import { Component, OnInit } from '@angular/core'
import { environment } from 'src/environments/environment'

@Component({
  selector: 'app-central-acessos-home',
  template: '',
  standalone: false
})
export class CentralAcessosHomeComponent implements OnInit {
  url: string = ''

  constructor() {
    this.url = environment.centralAcessos
  }

  ngOnInit(): void {
    window.open(this.url, '_self')
  }
}
